// src/Components/canvas_drag_N_DROP/RightSettingsDrawer.tsx
import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Node } from "reactflow";
import SettingsPanel from "./SettingsPanel";

/**
 * Panneau latéral à droite, 100% hauteur, avec overlay qui bloque les clics derrière.
 * Ne se ferme jamais sur clic extérieur ; seulement ✕ ou Échap.
 */
export default function RightSettingsDrawer({
  open,
  node,
  onClose,
  onUpdate,
  availableNodes = [],
}: {
  open: boolean;
  node: Node | null;
  onClose: () => void;
  onUpdate: (updated: Node) => void;
  availableNodes?: Node[];
}) {
  const { t } = useTranslation('canvas');

  // Fermer avec Esc
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && open) onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        right: 0,
        height: "100%",
        width: open ? 400 : 0,
        background: "#fff",
        borderLeft: open ? "1px solid #e5e7eb" : "none",
        boxShadow: open ? "-4px 0 20px rgba(0,0,0,0.15)" : "none",
        transition: "width 220ms ease, box-shadow 220ms ease",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        pointerEvents: open ? "auto" : "none",
        zIndex: 10,
      }}
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      role="complementary"
      aria-label={t('rightDrawer.ariaLabel')}
    >
      {open && node && (
        <SettingsPanel
          key={node.id}
          node={node}
          onClose={onClose}
          onUpdate={onUpdate}
          mode="dock"
          availableNodes={availableNodes}
        />
      )}
    </div>
  );
}
